/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import { Link } from 'react-router';
import {
  injectIntl,
} from 'react-intl';
import {
  Grid,
  Row,
  Col,
  Panel,
  Table,
} from 'react-bootstrap';
import IntlMsg from 'lorautils/intl/IntlMsg';
import Toolbar from 'loracoms/Toolbar';
import { callAPI } from 'lorautils/api';
import ShowIf from 'loracoms/ShowIf';
import LoadingTable from 'loracoms/LoadingTable';
import ScatterChart from 'loracoms/ScatterChart';
import HeatmapChart from 'loracoms/HeatmapChart';
import InlineSelect from 'loracoms/InlineSelect';
import loadingImg from 'loraimages/chart_loading.gif';
import SortBtn from 'loracoms/SortBtn';
import styles from './styles.scss';

const propTypes = {
  intl: React.PropTypes.any.isRequired,
  pushState: React.PropTypes.func.isRequired,
};

class QualityDeail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      heatmapData: [],
      deviceList: [],
      queryHours: 6,
      sortKey: 'deveui',
      listStatus: 'pending',
      heatStatus: 'pending',
    };
    this.intlMsg = new IntlMsg(props.intl, 'network.qualityView');
  }

  componentDidMount() {
    this.mounted = true;
    this.loadNetworkAnalysisList();
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  loadNetworkAnalysisList() {
    this.setState({ listStatus: 'pending', heatStatus: 'pending' });

    callAPI({
      endpoint: '/na/device_quality_summary',
      query: {
        hours: this.state.queryHours,
      },
    }).then((data) => {
      if (this.mounted) {
        this.setState({
          listStatus: 'success',
          deviceList: data,
        });
      }
    }).catch(() => {
      this.setState({
        listStatus: 'failure',
      });
    });

    callAPI({
      endpoint: '/na/packet_quality_summary',
      query: {
        hours: this.state.queryHours,
        heatmap: 1,
      },
    }).then((data) => {
      if (this.mounted) {
        this.setState({
          heatStatus: 'success',
          heatmapData: data,
        });
      }
    }).catch(() => {
      this.setState({
        heatStatus: 'failure',
      });
    });
  }

  handleSort(sort) {
    const deviceList = this.state.deviceList || [];
    let sortOrder = true;
    let sortKey = '';
    if (sort.startsWith('-')) {
      sortOrder = true;
      sortKey = sort.substr(1);
    } else {
      sortOrder = false;
      sortKey = sort;
    }
    deviceList.sort((a, b) => {
      if (sortOrder) {
        return a[sortKey] >= b[sortKey];
      }
      return a[sortKey] <= b[sortKey];
    });
    this.setState({
      deviceList,
      sortKey,
    });
  }

  render() {
    const { pushState } = this.props;
    const { heatmapData, deviceList, listStatus, heatStatus } = this.state;
    const sortKey = this.state.sortKey || null;
    const heatmapX = [];
    const heatmapY = [];
    let heatmapList = [];
    const scatterData = [];

    if (deviceList.length !== 0) {
      for (let i = 0; i < deviceList.length; i += 1) {
        const row = [
          deviceList[i].rssi_avg.toFixed(2),
          deviceList[i].lorasnr_avg.toFixed(2),
          deviceList[i].packet_loss_rate.toFixed(2),
          String(deviceList[i].deveui),
        ];
        scatterData.push(row);
      }
    }
    if (heatmapData.length !== 0) {
      heatmapData.xedges.forEach((e) => {
        heatmapX.push(String(e.toFixed(1)));
      });
      heatmapData.yedges.forEach((e) => {
        heatmapY.push(String(e.toFixed(1)));
      });
      heatmapList = heatmapData.heatmap_list;
    }
    const thead = (
      <thead>
        <tr>
          <th>
            {this.intlMsg.msg('thead.name')}
            <SortBtn
              sortName="name"
              highLight={sortKey === 'name'}
              handleSort={s => this.handleSort(s)}
            />
          </th>
          <th>
            {this.intlMsg.msg('thead.deveui')}
            <SortBtn
              sortName="deveui"
              highLight={sortKey === 'deveui'}
              handleSort={s => this.handleSort(s)}
            />
          </th>
          <th>
            {this.intlMsg.msg('thead.snrAvg')}
            <SortBtn
              sortName="lorasnr_avg"
              highLight={sortKey === 'lorasnr_avg'}
              handleSort={s => this.handleSort(s)}
            />
          </th>
          <th>
            {this.intlMsg.msg('thead.snrStd')}
            <SortBtn
              sortName="lorasnr_stddev"
              highLight={sortKey === 'lorasnr_stddev'}
              handleSort={s => this.handleSort(s)}
            />
          </th>
          <th>
            {this.intlMsg.msg('thead.rssiAvg')}
            <SortBtn
              sortName="rssi_avg"
              highLight={sortKey === 'rssi_avg'}
              handleSort={s => this.handleSort(s)}
            />
          </th>
          <th>
            {this.intlMsg.msg('thead.rssiStd')}
            <SortBtn
              sortName="rssi_stddev"
              highLight={sortKey === 'rssi_stddev'}
              handleSort={s => this.handleSort(s)}
            />
          </th>

          <th>
            {this.intlMsg.msg('thead.upPacketCount')}
            <SortBtn
              sortName="packet_total"
              highLight={sortKey === 'packet_total'}
              handleSort={s => this.handleSort(s)}
            />
          </th>
          <th>
            {this.intlMsg.msg('thead.packetLossRate')}
            <SortBtn
              sortName="packet_loss_rate"
              highLight={sortKey === 'packet_loss_rate'}
              handleSort={s => this.handleSort(s)}
            />
          </th>
        </tr>
      </thead>
    );
    const hoursStr = this.intlMsg.msg('hours');
    const rightTools = [{
      type: 'buttons',
      buttons: [(
        <InlineSelect
          options={[{
            label: `1 ${hoursStr}`,
            value: 1,
          }, {
            label: `6 ${hoursStr}`,
            value: 6,
          },
          {
            label: `12 ${hoursStr}`,
            value: 12,
          }, {
            label: `24 ${hoursStr}`,
            value: 24,
          }, {
            label: `72 ${hoursStr}`,
            value: 72,
          }]}
          values={[this.state.queryHours]}
          onChange={(selected) => {
            this.setState({
              queryHours: selected[0],
            }, () => {
              this.loadNetworkAnalysisList();
            });
          }}
        />
      )],
    }];
    return (
      <Grid fluid>
        <Row>
          <Col md={12}>
            <Toolbar
              brandTitle={this.intlMsg.msg('title')}
              rightTools={rightTools}
            />
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <Panel
              bsStyle="aisz-white"
              header={this.intlMsg.msg('deviceScatterHeader')}
              className={styles.panel}
            >
              <ShowIf if={listStatus === 'pending'}>
                <div className={styles.loading}>
                  <img src={loadingImg} alt="" />
                </div>
              </ShowIf>
              <ScatterChart
                series={[{
                  type: 'scatter',
                  data: scatterData,
                }]}
                tooltip={{
                  formatter: obj => `DevEUI: '${obj.data[3]}<br />
                            ${this.intlMsg.msg('average')}RSSI: ${obj.data[0]}<br />
                            ${this.intlMsg.msg('average')}SNR: ${obj.data[1]}<br />
                            ${this.intlMsg.msg('loss')}: ${obj.data[2]}<br />`,
                }}
                grid={{
                  left: 50,
                  top: 30,
                  right: 40,
                }}
                xAxis={{
                  name: 'RSSI',
                  scale: true,
                  splitLine: {
                    lineStyle: {
                      type: 'dashed',
                    },
                  },
                }}
                yAxis={{
                  name: 'SNR',
                  scale: true,
                  splitLine: {
                    lineStyle: {
                      type: 'dashed',
                    },
                  },
                }}
                visualMap={[{
                  orient: 'horizontal',
                  align: 'left',
                  dimension: 2,
                  text: [this.intlMsg.msg('loss')],
                  min: 0,
                  max: 1,
                  calculable: true,
                  inRange: {
                    color: ['#50a3ba', '#eac736', '#d94e5d'],
                  },
                }]}
              />
            </Panel>
          </Col>
          <Col md={6}>
            <Panel
              bsStyle="aisz-white"
              header={this.intlMsg.msg('packetHeatmapHeader')}
              className={styles.panel}
            >
              <ShowIf if={heatStatus === 'pending'}>
                <div className={styles.loading}>
                  <img src={loadingImg} alt="" />
                </div>
              </ShowIf>
              <HeatmapChart
                tooltip={{
                  formatter: () => '',
                }}
                series={[{
                  type: 'heatmap',
                  data: heatmapList,
                  itemStyle: {
                    emphasis: {
                      borderColor: '#333',
                      borderWidth: 1,
                    },
                  },
                  progressive: 1000,
                  animation: false,
                }]}
                xAxis={{
                  name: 'RSSI',
                  type: 'category',
                  data: heatmapX,
                }}
                yAxis={{
                  name: 'SNR',
                  type: 'category',
                  data: heatmapY,
                }}
                visualMap={{
                  text: [this.intlMsg.msg('density')],
                  orient: 'horizontal',
                  align: 'left',
                  min: 0,
                  max: 10,
                  calculable: true,
                  realtime: false,
                  inRange: {
                    color: ['#313695', '#4575b4', '#74add1', '#abd9e9', '#e0f3f8',
                      '#ffffbf', '#fee090', '#fdae61', '#f46d43', '#d73027', '#a50026'],
                  },
                }}
                grid={{
                  left: 50,
                  top: 30,
                  right: 40,
                }}
              />
            </Panel>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Panel
              className={styles.overflowPanel}
              bsStyle="aisz-white"
              header={this.intlMsg.msg('deviceListHeader')}
            >
              {listStatus === 'success' &&
              <Table className="aisz-table-light" striped hover bordered responsive>
                {thead}
                <tbody>
                  {
                    deviceList.map((r, idx) => (
                      <tr key={String(idx)}>
                        <td>{r.name}</td>
                        <td>
                          <Link onClick={() => pushState(`/network/quality/${r.deveui}`)}>
                            {r.deveui}
                          </Link>
                        </td>
                        <td>{(r.lorasnr_avg).toFixed(2)}</td>
                        <td>{(r.lorasnr_stddev).toFixed(2)}</td>
                        <td>{(r.rssi_avg).toFixed(2)}</td>
                        <td>{(r.rssi_stddev).toFixed(2)}</td>
                        <td>{r.packet_lost} / {r.packet_total}</td>
                        <td>{(r.packet_loss_rate * 100).toFixed(2)}%</td>
                      </tr>
                    ))
                  }
                </tbody>
              </Table>
              }
              {listStatus === 'pending' &&
              <LoadingTable rows={1} cols={8} className="aisz-table-light">
                {thead}
              </LoadingTable>
              }
            </Panel>
          </Col>
        </Row>
      </Grid>
    );
  }
}

QualityDeail.propTypes = propTypes;

export default connect(
  () => ({}),
  { pushState: routerActions.push },
)(injectIntl(QualityDeail));




// WEBPACK FOOTER //
// ./src/containers/Network/coms/QualityView/coms/QualityDetail/index.jsx